import deephowApiServerWrapper from "@/server/api-server";

export const fetchVersionHistoryByWorkflowId = ({ workflowId, lastest = false, previous = false }) => {
  /* allVersions: true, */
  const params = {
    latest: lastest || undefined,
    onlyPreDuplicated: previous || undefined,
  };
  return deephowApiServerWrapper("get", `/v1/workflows/${workflowId}/version-histories`, { params });
};

export default deephowApiServerWrapper;
